/* eslint-disable radix */
/* eslint-disable prefer-const */
import React, { useState, useEffect, useContext } from 'react';
import _ from 'lodash';

import { GeneralContext } from '../../core/app-context/GeneralContext';
import CreateReturnReasonDialog from './components/CreateReturnReasonDialog';
import ReturnReasons from './components/ReturnReasons';
import DevolutionPreferences from './components/DevolutionPreferences';
import ReturnWindowDays from './components/ReturnWindow';
import { Box } from '@material-ui/core';
import { PrivatePageStructure } from '../../shared/components/PrivatePageStructure';
import Categories from './components/Categories';
import useFetchConfigurationRules from './hooks/useFetchConfigurationRules';
import Services from './services';

import useGlobalStore from '../../shared/store/globalStore';

export default function ConfigurationRules() {
  const { setSideMenu, setIdMenuSelected, setErrorMessage, setSuccessMessage } =
    useContext(GeneralContext);
  useFetchConfigurationRules();
  const store = useGlobalStore((state) => state.general.store);
  const loading = useGlobalStore((state) => state.configurationRules.loading);
  const returnReasons = useGlobalStore(
    (state) => state.configurationRules.returnReasons,
  );
  const addReturnReason = useGlobalStore(
    (state) => state.configurationRules.addReturnReason,
  );
  const categories = useGlobalStore(
    (state) => state.configurationRules.categories,
  );
  const storeConfigs = useGlobalStore(
    (state) => state.configurationRules.storeConfigs,
  );
  const fetchedData = useGlobalStore(
    (state) => state.configurationRules.fetched,
  );
  const discardChanges = useGlobalStore(
    (state) => state.configurationRules.discardChanges,
  );
  const setDevolutionPreferenceSelection = useGlobalStore(
    (state) => state.configurationRules.setDevolutionPreferenceSelection,
  );
  const setReturnWindow = useGlobalStore(
    (state) => state.configurationRules.setReturnWindow,
  );
  const toggleCategorySelection = useGlobalStore(
    (state) => state.configurationRules.toggleCategorySelection,
  );
  const [openDialog, setOpenDialog] = useState(false);
  const [changed, setChanged] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (
      !_.isEqual(fetchedData.returnReasons, returnReasons) ||
      !_.isEqual(fetchedData.categories, categories) ||
      !_.isEqual(fetchedData.storeConfigs, storeConfigs)
    ) {
      setChanged(true);
    } else {
      setChanged(false);
    }
  }, [returnReasons, categories, storeConfigs]);

  useEffect(() => {
    setSideMenu('reversa');
    setIdMenuSelected('ruleConfig');
  }, [setSideMenu, setIdMenuSelected]);

  function handleDiscardChanges() {
    if (changed) {
      discardChanges();
    }
    return;
  }

  async function handleSaveChanges() {
    setSaving(true);
    if (changed) {
      // Non optimal solution, but it works for now... It is just a refactor of
      // the old code, I didn't want to change too much now... Must refactor this
      // The correct way to do this is to update only the data that changed, not everything
      let ineligleCategoriesIdsToRemove = [];
      for (let i = 0; i < categories.length; i += 1) {
        if (fetchedData.categories[i].eligible && !categories[i].eligible) {
          ineligleCategoriesIdsToRemove.push(categories[i].id);
        }
      }
      let ineligleCategoriesIdsToAdd = [];
      for (let i = 0; i < categories.length; i += 1) {
        if (!fetchedData.categories[i].eligible && categories[i].eligible) {
          ineligleCategoriesIdsToAdd.push(categories[i].id);
        }
      }
      // remove __typename and id from storeConfigs (not present on mutation args)
      const cleanedStoreConfigs = { ...storeConfigs }; // No nested objecte, so it is ok to a shallow copy
      delete cleanedStoreConfigs.__typename;
      delete cleanedStoreConfigs.id;
      const saveResult = await Services.saveStoreConfigsAndRules({
        storeId: store.id,
        markIneligibleCategories: ineligleCategoriesIdsToAdd,
        removeIneligibleCategories: ineligleCategoriesIdsToRemove,
        returnReasons: returnReasons.map((item) => ({
          id: item.id,
          isSelected: item.isSelected,
        })),
        updateStoreConfigs: {
          storeId: store.id,
          ...cleanedStoreConfigs,
        },
      });
      if (!saveResult) {
        setErrorMessage('Erro ao salvar as configurações');
      } else {
        setSuccessMessage('Configurações salvas com sucesso');
      }
    }
    setSaving(false);
  }

  return (
    <PrivatePageStructure
      title="Configurações e Regras"
      loading={loading}
      btn1Action={handleDiscardChanges}
      btn2Action={handleSaveChanges}
      btn2Loading={saving}
      btn1Disable={!changed}
      btn2Disable={!changed}
    >
      <DevolutionPreferences
        autoApprove={storeConfigs?.autoApproveDevolution}
        onAutoApproveChange={(event) =>
          setDevolutionPreferenceSelection(
            'autoApproveDevolution',
            event.target.checked,
          )
        }
        considerItems={storeConfigs?.considerDevolutionItems}
        onConsiderItemsChange={(event) =>
          setDevolutionPreferenceSelection(
            'considerDevolutionItems',
            event.target.checked,
          )
        }
        searchVtex={storeConfigs?.enableVtexItemsSearch}
        onSearchVtexChange={(event) =>
          setDevolutionPreferenceSelection(
            'enableVtexItemsSearch',
            event.target.checked,
          )
        }
        enableReturnMethodSelectionEmail={
          storeConfigs?.enableReturnMethodSelectionEmail
        }
        onEnableReturnMethodSelectionEmailChange={(event) =>
          setDevolutionPreferenceSelection(
            'enableReturnMethodSelectionEmail',
            event.target.checked,
          )
        }
        enableOrderNumberInput={storeConfigs?.enableOrderNumberInput}
        onEnableOrderNumberInputChange={(event) =>
          setDevolutionPreferenceSelection(
            'enableOrderNumberInput',
            event.target.checked,
          )
        }
        searchMemphis={storeConfigs?.enableMemphisOrderInfoSearch}
        onSearchMemphisChange={(event) =>
          setDevolutionPreferenceSelection(
            'enableMemphisOrderInfoSearch',
            event.target.checked,
          )
        }
      />
      <Box sx={{ height: '20px' }} />
      <ReturnReasons
        returnReasons={returnReasons}
        setOpenCreateReturnReasonDialog={setOpenDialog}
      />
      <Box sx={{ height: '20px' }} />
      <ReturnWindowDays
        returnWindowDays={storeConfigs?.returnWindowDays ?? 0}
        setReturnWindowDays={setReturnWindow}
      />
      <Box sx={{ height: '20px' }} />
      <Categories
        categories={categories}
        setCategory={toggleCategorySelection}
      />
      <CreateReturnReasonDialog
        isDialogOpen={openDialog}
        setIsDialogOpen={setOpenDialog}
      />
    </PrivatePageStructure>
  );
}
